export type ScenarioTaskDiagramRenderMode = '2d' | '3d';

export function normalizeScenarioTaskDiagramRenderMode(
  value: unknown
): ScenarioTaskDiagramRenderMode {
  return value === '3d' ? '3d' : '2d';
}
